import React, { useState, useEffect } from 'react';

const MobileGameNav = ({ 
  onBack, 
  gameStatus, 
  currentTurn, 
  playerColor, 
  roomId,
  onToggleChat,
  unreadMessages = 0
}) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);
    
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  if (!isMobile) return null;

  const getStatusText = () => {
    if (gameStatus.isGameOver) {
      if (gameStatus.winner) {
        return gameStatus.winner === playerColor ? '🎉 You Won!' : '😔 You Lost';
      }
      return '🤝 Draw';
    }
    
    return currentTurn === playerColor ? '🎯 Your Turn' : '⏳ Waiting...';
  };

  const getStatusColor = () => {
    if (gameStatus.isGameOver) {
      if (gameStatus.winner === playerColor) return '#4ecdc4';
      if (gameStatus.winner) return '#ff6b6b';
      return '#ffd700';
    }
    
    return currentTurn === playerColor ? '#4ecdc4' : '#ffaa00';
  };

  return (
    <div className="mobile-game-nav">
      <div className="mobile-nav-top">
        <button className="mobile-back-btn" onClick={onBack}>
          ← Back
        </button>
        <div className="mobile-room-info">
          <span className="mobile-room-id">Room: {roomId}</span>
        </div>
        <button 
          className="mobile-chat-btn" 
          onClick={onToggleChat}
        >
          💬
          {unreadMessages > 0 && (
            <span className="mobile-chat-badge">{unreadMessages}</span>
          )}
        </button>
      </div>
      
      <div 
        className="mobile-game-status"
        style={{ backgroundColor: getStatusColor() }}
      >
        <span className="mobile-status-text">{getStatusText()}</span>
      </div>
    </div>
  );
};

export default MobileGameNav;